<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            style="height: 100%"
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <div class="dataLeft">
              <div class="dirTop">
                <el-scrollbar>
                  <tree
                    :isSearch="isSearch"
                    @initFun="initQuery"
                    @nodeClick="nodeClick"
                  ></tree>
                </el-scrollbar>
              </div>
              <div class="dirBottom">
                <el-input
                  style="width: 96%"
                  class="inputStyle"
                  @keyup.enter.native="onkeyUp"
                  v-model="number"
                  size="small"
                  :placeholder="$t('common.searchTip')"
                ></el-input>
                <i-table
                  :list="list"
                  :height="height"
                  ref="carTable"
                  :options="option"
                  :columns="columns"
                  :operates="operates"
                  @rowClick="rowClick"
                ></i-table>
                <IPagination ref="page" @PageFun="changeSize"></IPagination>
              </div>
            </div>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="dataRight">
        <div class="stateTable">
          <el-scrollbar>
            <ChangeTime
              ref="changeTime"
              :bind-battery="batteryNumber"
            ></ChangeTime>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BatteryAnalysis from "./BatteryAnalysis.js";
export default BatteryAnalysis;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
